import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	uploadError: {
		id: 'proforma.request-create.ui.proforma-request-create.utils.attachment-lifecycle-handlers.upload-error',
		defaultMessage: 'Error uploading attachment',
		description: 'Message for when an error occurs during attachment upload',
	},
	uploadErrorDescription: {
		id: 'proforma.request-create.ui.proforma-request-create.utils.attachment-lifecycle-handlers.upload-error-description',
		defaultMessage: 'An error occurred when uploading an attachment',
		description: 'Description on flag for when an error occurs during an attachment upload',
	},
});
